import * as Yup from 'yup';

const requiredMessage = `This field is required`;

export const reportCategoryValidationSchema = () => {
  const fields: any = {
    report_category: Yup.string().trim().required(requiredMessage).nullable(),
  };

  return Yup.object().shape(fields);
};
